import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/material';
import {amber, blue, blueGrey, green, grey, orange, red} from '@mui/material/colors';
import Typography from '@mui/material/Typography';

const getColorByStatusCategory = (statusCategory) => {
    switch (statusCategory) {
        case 'Applied':
            return blue[500];
        case 'Offered':
            return orange[500];
        case 'Accepted':
            return green[500];
        case 'Admitted':
            return amber[500];
        case 'Rejected':
            return red[500];
        case 'Reserved':
            return blueGrey[500];
        case 'Withdrawl':
            return blueGrey[500];
        case 'Enquiry':
            return blue.A400;
        default:
            return grey[500];
    }
};

const Div = styled('div')(({color}) => ({
    backgroundColor: color,
    color: grey[50],
    fontWeight: 600,
    textAlign: 'center'
}));

const ProfileStatus = ({status, statusCategory, isStudentProfile}) => {
    const color = getColorByStatusCategory(statusCategory);

    return (!isStudentProfile
            ? <Div
                sx={{
                    width: '70px',
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    borderRadius: 3
                }}
                color={color}
            >
                <Typography
                    noWrap
                    title={status}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'center',
                        width: '100%'
                    }}
                    variant="subtitle2">{status}</Typography>
            </Div>
            : <Div
                color={color}
                sx={{
                    paddingLeft: 2,
                    paddingRight: 2,
                    paddingTop: 1,
                    paddingBottom: 1,
                    borderRadius: 5
                }}
            >
                <Typography variant="body1">{status}</Typography>
            </Div>
    );
};

ProfileStatus.defaultProps = {
    isStudentProfile: false
};

ProfileStatus.propTypes = {
    status: PropTypes.string,
    statusCategory: PropTypes.string,
    isStudentProfile: PropTypes.bool.isRequired
};
export default ProfileStatus;